import { render, staticRenderFns } from "./Variations.vue?vue&type=template&id=daa3af28"
import script from "./Variations.vue?vue&type=script&lang=js"
export * from "./Variations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports